/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react'
import PropTypes from 'prop-types'
import Card from '../../Card'

const CardListItem = ({ className, onClick, children }) => (
  <dd onClick={onClick}>
    <Card className={className}>{children}</Card>
  </dd>
)

CardListItem.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
}

export default CardListItem
